import { Content } from "@iventis/translations/content/typed-content";
import { useLocation } from "react-router";
import React, { FunctionComponent, useState, useEffect } from "react";
import { Body1, Body2, Header4, Header5 } from "@iventis/styles/src/components/texts";
import { media, TypographyColorsEnum, styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { passwordHeaderMargin } from "@iventis/styles/src/atomic-rules";
import { SUPPORT_EMAIL } from "@iventis/utilities";
import { TextButton } from "@iventis/styles/src/components/button";

import { LoginPanelContainer, LoginPageContainer } from "@iventis/components/src/login-containers";
import { IventisFooter, SiteLogoComponent } from "@iventis/components";
import { useHistory } from "@iventis/subscriptions";
import { SetPasswordForm } from "./set-password-form";
import { localPasswordCanBeSet, setLocalPassword } from "./set-password";
import { LoginBackground } from "./login";

export const SetPasswordPanel: FunctionComponent = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const accessKey = urlParams.get("access-key");
    const secretAccessKey = urlParams.get("secret-access-key");
    const translate = useIventisTranslate();
    const history = useHistory();

    const handleSetPassword = async (newPassword: string): Promise<void> => {
        await setLocalPassword(accessKey, secretAccessKey, newPassword);
    };

    const [linkIsValid, setLinkIsValid] = useState<boolean>(true);

    useEffect(() => {
        const abortController = new AbortController();
        localPasswordCanBeSet(accessKey, secretAccessKey, abortController.signal).then((valid) => {
            setLinkIsValid(valid);
        });
        return () => abortController.abort();
    }, []);

    return (
        <LoginBackground>
            <LoginPageContainer>
                <LoginPanelContainer>
                    <SiteLogoComponent />
                    {linkIsValid ? (
                        <>
                            <Header5 style={{ marginTop: passwordHeaderMargin, marginBottom: "7px" }}>{translate(Content.login.headings.setPass)}</Header5>
                            <Body2Scalable data-testid="valid-set-password-link">{translate(Content.login.subHeadings.setPass)}</Body2Scalable>
                            <SetPasswordForm handlePasswordSubmit={handleSetPassword} />
                        </>
                    ) : (
                        <>
                            <Header4 color={TypographyColorsEnum.CORE} style={{ marginTop: passwordHeaderMargin, marginBottom: "7px" }}>
                                {translate(Content.login.error.resetPasswordLinkInvalidTitle)}
                            </Header4>
                            <Body1 data-testid="invalid-set-password-link">{`${translate(Content.login.error.resetPasswordLinkInvalid)} ${SUPPORT_EMAIL}.`}</Body1>
                            <TextButton onClick={() => history.push("/forgotten-password")}>{Content.login.links.forgotPass}</TextButton>
                        </>
                    )}
                </LoginPanelContainer>
                <IventisFooter />
            </LoginPageContainer>
        </LoginBackground>
    );
};

const Body2Scalable = styled(Body2)`
    ${media.extraSmall} {
        display: none;
    }
`;

export default SetPasswordPanel;
